import React, { Component } from "react";
import { toast } from "react-toastify";
import {
  Pagination as MuiPagination,
  Grid,
  CircularProgress,
  Modal,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import Moment from "moment";
import { API_URL, UPLOADS_BUCKET } from "../../config";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";

Moment.locale("en");

class AdminUserPhotosetsModal extends Component {
  _isMounted = false;

  state = {
    loading: false,
    activePage: 1,
    pages: [],
    count: this.props.count,
    photosets: this.props.data.photosetlist,
    tiers: this.props.data.tierList,
    selectedPages: [],
    photolist: this.props.photos,
    showModal: false,
    selectedPhotoset: 0,
    modalLoading: true,
    modalPhotos: [],
    photosetDetails: [],
    photoCount: 0,
  };

  componentDidMount() {
    this._isMounted = true;
    this.pagination();
    //this.getAdminList();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  pagination = (i = this.state.activePage) => {
    const x = 20;
    let divisions = Math.ceil(this.state.count / x);
    if (divisions < 1) divisions = 1;

    let pages = [];

    if (i < 1) i = 1;
    if (i > divisions) i = divisions;
    this.setState({ activePage: i });

    for (let number = 1; number <= divisions; number++) {
      pages.push(
        <Pagination.Item
          key={number}
          active={number === i}
          onClick={() => {
            this.setState({ activePage: number });
            this.pagination(number);
          }}
        >
          {number}
        </Pagination.Item>
      );
    }

    // select the pages to show
    const floor = (i - 1) * x;
    const ceil = (i - 1) * x + x;

    console.log("floor", floor);
    console.log("ceil", ceil);

    const photosets = this.state.photosets;
    const selectedPages = photosets.slice(floor, ceil);

    console.log(selectedPages);

    let sp = [];

    selectedPages.forEach((item) => {
      let sp_list = {
        photosetName: item.photosetName,
        createdAt: item.createdAt,
        id: item.id,
        photosetStatus: item.photosetStatus,
        userId: item.userId,
        photos: this.state.photolist[item.id],
      };

      sp.push(sp_list);
    });

    console.log(sp);

    if (this._isMounted)
      this.setState({
        pages: pages,
        selectedPages: sp,
        loading: false,
      });
  };

  getAdminList = async () => {
    //admin/v1/photosets/list
    try {
      const token = this.props.token;

      const body = JSON.stringify({
        // type: "photosets",
      });

      const response = await fetch(
        API_URL + "/admin/v1/photosets/list",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
          method: "POST",
        }
      );

      const responseData = await response;
      if (responseData.status === 200) {
        const responseJson = await responseData.json();

        console.log(responseJson);
        let photos = [];
        const photolist = responseJson.photolist;

        photolist.forEach((item) => {
          const photosetId = item.photosetId;
          photos[photosetId] = item.photos;
        });

        this.setState({
          count: responseJson.photosetlist.length,
          photosets: responseJson.photosetlist,
          photolist: photos,
          tiers: responseJson.tierList,
        });

        this.pagination();
      } else {
        toast.warn("Something went wrong: Error " + responseData.status);
        this.setState({ loading: false });
      }
    } catch (err) {
      toast.error("Error getting photoset list from endpoint: " + err);
    }
  };

  showModal = (id) => {
    if (this._isMounted)
      this.setState({
        showModal: true,
        selectedPhotoset: id,
        modalPhotos: [],
        photosetDetails: [],
        modalLoading: true,
      });

    this.getPhotosetDetails();
  };

  getPhotos = async (userId, photosetId) => {
    try {
      const token = this.props.token;

      const body = JSON.stringify({
        setId: this.state.selectedPhotoset,
      });

      const response = await fetch(
        API_URL + "/admin/v1/photosets/list/photos",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
          method: "POST",
        }
      );

      const responseData = await response;
      if (responseData.status === 200) {
        const responseJson = await responseData.json();
        console.log(responseJson);

        const s3 = new S3Client({
          region: "us-east-1",
          credentials: this.props.AWS?.config?.credentials,
        });

        this.setState({ photoCount: responseJson.length });

        responseJson.forEach(async (item, index) => {
          let filename = item.fileName.replace(/\.[^/.]+$/, "") + ".jpg";
          let key = "photosets/" + userId + "/" + photosetId + "/thumbs/" + filename;

          const command = new GetObjectCommand({
            Bucket: UPLOADS_BUCKET,
            Key: key,
          });

          try {
            const url = await getSignedUrl(s3, command, { expiresIn: 3600 });
            let newImage = {
              src: url,
              key: item.id,
              width: 0.5,
              height: 0.5,
              status: item.photoStatus,
              f: item.fileName,
              alt: "thumbs",
            };

            const newImages = this.state.modalPhotos.concat(newImage);

            if (this._isMounted) {
              this.setState({
                modalPhotos: newImages,
              });
            }
          } catch (err) {
            toast.warn("Failed to get thumbs", "", 10000);
          }
        });
      } else {
        toast.warn("Something went wrong: Error " + responseData.status);
      }
      this.setState({ modalLoading: false });
    } catch (err) {
      toast.error("Error getting photoset list from endpoint: " + err);
      this.setState({ modalLoading: false });
    }
  };

  render() {
    if (this.state.loading)
      return (
        <Box sx={{ display: "flex", justifyContent: "center", my: 5 }}>
          <CircularProgress />
        </Box>
      );

    if (!this.state.loading && this.state.selectedPages.length === 0)
      return (
        <Box sx={{ mt: 5 }}>
          <Typography variant="h5">Empty</Typography>
        </Box>
      );

    return (
      <React.Fragment>
        <Box sx={{ p: 2, borderBottom: 1, borderColor: "divider" }}>
          <MuiPagination
            count={Math.ceil(this.state.count / 20)}
            page={this.state.activePage}
            onChange={(e, page) => this.pagination(page)}
            showFirstButton
            showLastButton
          />
        </Box>
        <Box sx={{ p: 2 }}>
          {this.state.selectedPages.map((item, index) => (
            <Paper
              key={index}
              elevation={2}
              sx={{
                mb: 2,
                p: 2,
                cursor: "pointer",
                "&:hover": { boxShadow: 4 },
              }}
              onClick={() => this.props.setMode(item.id)}
            >
              <Grid container>
                <Grid item xs>
                  <Grid container justifyContent="space-between">
                    <Grid item>
                      <Typography variant="h6">{item.photosetName}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body2">
                        {Moment.unix(item.createdAt).format("LLL")}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Typography variant="caption">{item.id}</Typography>
                </Grid>
              </Grid>
            </Paper>
          ))}
        </Box>
      </React.Fragment>
    );
  }
}

export default AdminUserPhotosetsModal;
